import styled from "styled-components";
import NarrowGrid from "../../../../../components/NarrowGrid";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import WarningButton from "../../../../../components/FormControls/WarningButton";
import MessageBox from "../../../../../components/MessageBox";
import request from "../../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { useEffect } from "react";

const StyledUserAndRulesLeftPane = styled.div`
	background-color: white;
	width: 369px;
	min-height: 573px;
    box-sizing: border-box;
	height: 100%;
	padding: 30px;
`;

function UserAndRulesLeftPane(props) {

    const navigate = useNavigate();

	const {gridColumns, gridData, gridStyle, selectedUser, userIdToSelect, onSelectGridItem, isAddMode, setIsAddMode, refreshUsersCallback} = props;

    const [showMessageBox, setShowMessageBox] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

	const handleClickCreateNewBranch = () => {
		if (setIsAddMode) {
			setIsAddMode(true);
			navigate('/settings/usersettings/main');
		}
	}

    const deleteUser = async () => {
        setShowMessageBox(false);

        setIsDeleting(true);
        let deleteData = {};
        deleteData.UserName = selectedUser.UserName;
        const resp = (await request('database', 'deleteUser', [deleteData]));
        if (resp.ok && refreshUsersCallback) {
            refreshUsersCallback();
            NotificationManager.success('User deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeleting(false);
    }

    return (
        <StyledUserAndRulesLeftPane>
			<NarrowGrid id='branchsetting_leftpane_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddMode} itemIdToSelect={userIdToSelect} onSelectGridItem={onSelectGridItem} gridStyle={gridStyle}></NarrowGrid>
			{!isAddMode && <PrimaryButton caption='Create new' onClick={() => handleClickCreateNewBranch()} style={{width:100, height:25, marginTop:20, float:'right'}}></PrimaryButton>}
			{isAddMode && <PrimaryButton caption='Cancel' onClick={() => setShowMessageBox(true)} style={{width:100, height:25, marginTop:20, float:'right'}}></PrimaryButton>}
			{!isAddMode && selectedUser && <SecondaryButton caption='Delete' isLoading={isDeleting} onClick={() => setShowMessageBox(true)} style={{width:75, height:25, marginTop:20}}></SecondaryButton>}
			

            { showMessageBox && <MessageBox
                text = {isAddMode ? 'Are you sure cancel?' : 'Are you sure you want to delete this user?'}
                yesText = {isAddMode ? 'Cancel' : 'Delete user'}
                noText = {isAddMode ? 'No' : 'Cancel'}
                isWarning = {!isAddMode}
                handleClickYes = {() => {
                        if (isAddMode) {
                            if (setIsAddMode) {
                                setIsAddMode(false);
                                setShowMessageBox(false);
                            }
                        } else {
                            deleteUser();
                        }
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
		</StyledUserAndRulesLeftPane>
    )
}

export default UserAndRulesLeftPane;